import auteur1 from 'assets/png/aut1.jpeg';
import auteur2 from 'assets/png/aut2.jpeg';
import classNames from 'utils/classNames';

interface Props {
  display: string;
}
const Auteur = ({ display }: Props) => {
  const DisplayCondition = 'Auteurs';
  const array = [
    {
      img: auteur1,
      title: 'Valéry Trosini-Désert',
      desc: " Pneumologue, Praticien Hospitalier, Responsable de l’Unité Fonctionnelle d'endoscopie Bronchique du Service de Pneumologie , Groupe Hospitalier Pitié-Salpêtrière, Assistance Publique - Hôpitaux de Paris ",
    },
    {
      img: auteur2,
      title: 'Camille TAILLÉ',
      desc: " Pneumologue, PU-PH, Centre de l'Asthme et des Allergies, Service de Pneumologie, Hôpital Bichat-Claude Bernard, Assistance Publique - Hôpitaux de Paris.",
    },
  ];

  return (
    <div className={classNames(display === DisplayCondition ? 'block' : 'hidden')}>
      <div className="flex flex-col lg:grid lg:grid-cols-2 sm:flex sm:flex-col">
        {array.map((m) => (
          <div className="flex flex-row lg:flex-col lg:items-center justify-center items-start  mb-5 lg:pr-4 lg:mb-8 sm:mb-5">
            <img src={m.img} alt="" className="rounded-5  lg:w-full lg:h-96" width="168px" height="300px" />{' '}
            {/* </div> */}
            <div className="flex flex-col flex-1 ml-4	lg:pt-4 lg:ml-0">
              <div className="2xl:text-base text-blue-600 text-26 font-semibold"> {m.title} </div>
              <div className="2xl:text-xs sm:text-sm text-lg text-blue-600 font-regular mt-5 text-justify	lg:text-xs">
                {' '}
                {m.desc}{' '}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Auteur;
